<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<embed :src="url + doc" type="application/pdf" width="100%" height="1000px"/>
	  	</v-col>
	  </v-row>


    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
    mixins: [ validarErrores, funcionesExcel ],
  	components:{
      Alerta,
      carga,
    },
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },
      url:'',
      doc: '',

    }),
    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),
    },
    async created () {
      //this.url = 'http://localhost:3004/organigrama/'
      this.url = 'https://escuelakpi.club/kpi/organigrama/'
      await this.initialize( )
    },
    methods: {
      initialize () {
      	this.cargar = true
        return this.$http.get('organigrama.v2').then(response=>{

          const departamentoBuscado = response.data.filter(item => item.id_puesto === this.getdatosUsuarioERPERP.idpuesto )[0].departamento

          console.log( departamentoBuscado )
          return this.$http.get('departamentos.activos').then(response=>{
            console.log( 'Departamentos' )
            const archivo = response.data.filter(item => item.departamento === departamentoBuscado )[0].archivo
            this.url += archivo
            this.cargar      = false
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })

          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

    },
  }
</script>
